import { useEffect, useMemo } from "react";
import useSiteSettings, { toAbsoluteAssetUrl } from "@/hooks/useSiteSettings";

export const APP_TITLE = "demo7";

export const resolveSiteFavicon = (settings = {}) => {
  const candidates = [
    settings.FaviconImage,
    settings.favicon_image,
    settings.faviconImage,
    settings.favicon_url,
    settings.faviconUrl,
    settings.site_favicon,
    settings.siteFavicon,
    settings.domainSettings?.favicon_image,
    settings.domainSettings?.faviconImage,
    settings.domain_settings?.favicon_image,
    settings.domain_settings?.faviconImage,
  ];
  const favicon = candidates.find((value) => typeof value === "string" && value.trim());
  return favicon ? toAbsoluteAssetUrl(favicon.trim()) : "";
};

const getFaviconType = (faviconUrl) => {
  if (/\.png(?:\?|$)/i.test(faviconUrl)) return "image/png";
  if (/\.svg(?:\?|$)/i.test(faviconUrl)) return "image/svg+xml";
  if (/\.webp(?:\?|$)/i.test(faviconUrl)) return "image/webp";
  return "image/x-icon";
};

const DynamicSiteMetadata = () => {
  const { settings } = useSiteSettings();
  const faviconUrl = useMemo(() => resolveSiteFavicon(settings), [settings]);

  useEffect(() => {
    document.title = APP_TITLE;
  }, []);

  useEffect(() => {
    const existingIcons = document.querySelectorAll(
      'link[rel~="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]'
    );
    existingIcons.forEach((link) => link.remove());

    if (!faviconUrl) return undefined;

    const faviconLink = document.createElement("link");
    faviconLink.rel = "icon";
    faviconLink.type = getFaviconType(faviconUrl);
    faviconLink.href = faviconUrl;
    faviconLink.dataset.backendFavicon = "true";
    document.head.appendChild(faviconLink);

    return () => faviconLink.remove();
  }, [faviconUrl]);

  return null;
};

export default DynamicSiteMetadata;
